import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import UploadImages from '@/plugins/graphql/mutations/v2/category-images-upload.gql';
import RemoveImages from '@/plugins/graphql/mutations/v2/category-images-remove.gql';
import CategoryFragment from '@/plugins/graphql/fragments/v2/ecommerce/category.gql';
import CategoryBasicFragment from '@/plugins/graphql/fragments/v2/category-basic.gql';
import { omit } from 'lodash';
import ImageUploadMixin from '../ImageUploadMixin';
let CategoryImageUploadMixin = class CategoryImageUploadMixin extends mixins(ImageUploadMixin) {
    async uploadImages(categoryUuid, images) {
        const inputImages = images.map((input) => input.file);
        const vm = this;
        await this.$apollo.mutate({
            mutation: UploadImages,
            variables: {
                input: {
                    categoryUuid,
                    images: inputImages,
                },
            },
            update(cache, { data }) {
                const { category } = data.categoryImagesUpload;
                vm.updateCategoryCache(cache, category);
            },
        });
    }
    async removeImages(categoryUuid, imageUuids) {
        const vm = this;
        await this.$apollo.mutate({
            mutation: RemoveImages,
            variables: {
                input: {
                    categoryUuid,
                    photos: imageUuids,
                },
            },
            update(cache, { data }) {
                const { category } = data.categoryImagesRemove;
                vm.updateCategoryCache(cache, category);
            },
        });
    }
    async updateCategoryCache(cache, category) {
        cache.writeFragment({
            uuid: category.uuid,
            fragment: CategoryFragment,
            data: category,
            fragmentName: 'Category',
        });
        const photoNode = category.galleryPhotos.edges[0];
        const featuredPhotoUrl = photoNode ? photoNode.node.photoUrl : null;
        const basicCategory = omit(category, 'ecommerceSubCategories', 'galleryPhotos');
        const categoryPayload = {
            ...basicCategory,
            featuredPhotoUrl,
        };
        cache.writeFragment({
            id: category.uuid,
            fragment: CategoryBasicFragment,
            data: categoryPayload,
            fragmentName: 'CategoryBasic',
        });
    }
};
CategoryImageUploadMixin = __decorate([
    Component
], CategoryImageUploadMixin);
export default CategoryImageUploadMixin;
